import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function Reklamdekoracio() {
  return (
    <SubPageLayout
      eyebrow="Reklámdekoráció"
      title="Mozgóreklám, amely Önnek dolgozik."
      intro="Haszongépjárművek és személyautók reklámdekorációja, molinók PVC ponyvából. Tervezés, vágóplotteres és nyomdai kivitelezés egy helyen."
      heroImage="/assets/gallery/lasi-01.jpg"
      bullets={[
        { title: "Tervezés és grafika", text: "Saját grafikusunk segít a logók és feliratok tervezésében és elhelyezésében." },
        { title: "Matricázás", text: "Plotterfóliák gyártása és felragasztása személyautókra, furgonokra, tehergépkocsikra, kamionokra. Nagyobb járműpark esetén kihelyezett munkavégzés." },
        { title: "Ponyvafestés", text: "Molinóktól egészen a kamionponyvákig." },
        { title: "Dekorációcsere", text: "Régi dekoráció eltávolítása, újradekorálás." },
      ]}
      gallery={SITE_IMAGES.adGallery}
    />
  );
}
